
import DrawerBtnGroup, { ContentItem } from '../../../../../../../common/components/organisme/DrawerBtnGroup/DrawerBtnGroup';

import ImageViewer from '../../../../../../../common/components/organisme/ImageViewer/ImageViewer';


//import PlanBTImage from './assets/planBT.jpg';


//First branch

export interface PlanBTImageViewProps {
  src?: string;
  contentWidget?: ContentItem[];

}
export default function PlanBTImageView({src, contentWidget}: PlanBTImageViewProps) {
    /*
  const content : ContentItem[]=[
    {
      title: 'Lampadaire',
      Icon: () => <Lamp size={25} color='#878686'/>,
      HeaderComponent: () => <Button label='Ajouter' variant='dark-parimary' iconRightType='plus' />,
      Content: () => <>

      <Table variant='dark' headerTitle={['Nom', 'Numéro']} bodyData={[{
        data: ['Lampadaire 1', '190'],
        id: '1'
      }, {
        data: ['Lampadaire 2', '0932'],
        id: '2'
      },
      {
        data: ['Lampadaire 3', '0282'],
        id: '3'
      },
      {
        data: ['Lampadaire 4', '2203'],
        id: '4'
      },
 
 


    ]}/></>,
      IconActive: () => <Lamp size={25} color='white'/>,
      path: '/main/plan-bt/1/lamp',
      reglexPah: /^\/main\/plan-bt\/1\/lamp(\/.*)?$/
     
    },
    {
      title: 'Client',
      HeaderComponent: () => <Button label='Ajouter' variant='dark-parimary' iconRightType='plus' />,
      Icon: () => <Human size={25} color='#878686'/>,
   
      Content: () => <>

      <Table variant='dark' headerTitle={['Nom', 'ID']} bodyData={[{
        data: ['Dela Matrin', '190'],
        id: '1'
      }, {
        data: ['Lix Pierre', '0932'],
        id: '2'
      },
      {
        data: ['Lola Marta', '0282'],
        id: '3'
      },
      {
        data: ['Mikana Amina', '2203'],
        id: '4'
      },
 
 


    ]}/></>,
      
      IconActive: () => <Human size={25} color='white'/>,
      path: '/main/plan-bt/1/client',
      reglexPah: /^\/main\/plan-bt\/1\/client(\/.*)?$/
    },
    {
      title: 'Poteau Electrique',
      Icon: () => <ElectricPole size={25} color='#878686'/>,
      HeaderComponent: () => <Button label='Ajouter' variant='dark-parimary' iconRightType='plus' />,
      Content: () => 
        <>
       </>,
      IconActive: () => <ElectricPole size={25} color='white'/>,
      path: '/main/plan-bt/1/electric-pole',
      reglexPah: /^\/main\/plan-bt\/1\/electric-pole(\/.*)?$/
    },
    {
      title: 'Raccordement',
      Icon: () => <Plug size={25} color='#878686'/>,
      HeaderComponent: () => <Button label='Ajouter' variant='dark-parimary' iconRightType='plus' />,
      Content: () =>       <>
      <Table variant='dark' headerTitle={['Nom', 'Numéro']} bodyData={[{
        data: ['Raccodement 1', '190'],
        id: '1'
      }, {
        data: ['Raccodement 2', '0932'],
        id: '2'
      },
  
 
 


    ]}/></>,
      IconActive: () => <Plug size={25} color='white'/>,
      path:'/main/plan-bt/1/connection',
      reglexPah: /^\/main\/plan-bt\/1\/connection(\/.*)?$/
    }
  ] 
*/
  return (
    <ImageViewer src={src} WidgetTop={() => <DrawerBtnGroup content={contentWidget || []}  />}/>
  )
}
